import styled from 'styled-components';

export const ParagraphFieldSC = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  font-weight: 600;
  font-size: 14px;

  img {
    margin-right: 15px;
  }
`;
